/**
 * Created by huchangwen on 17/1/9.
 */


var configUtil={

  getMtopPrefix: function () {
    if (window.location.host.indexOf("waptest.taobao.com") != -1) {
      return 'api';
    } else if (window.location.host.indexOf("wapa.taobao.com") != -1) {
      return 'acs';
    } else if (window.location.host.indexOf("m.taobao.com") != -1) {
      return 'api';
    } else {
      return 'api';
    }
  },

  getMtopSubDomain: function () {
    if (window.location.host.indexOf("waptest.taobao.com") != -1) {
      return 'waptest';
    } else if (window.location.host.indexOf("wapa.taobao.com") != -1) {
      return 'wapa';
    } else if (window.location.host.indexOf("m.taobao.com") != -1) {
      return 'm';
    } else {
      return 'waptest';
    }
  },


  getMtopMainDomain: function () {
    return 'taobao.com';
  }
}

export default configUtil




// WEBPACK FOOTER //
// ./src/assets/js/configUtil.js